module.exports = __webpack_public_path__ + "static/media/KQ.e97f6f5f.png";